// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import VeeValidate from 'vee-validate';
import BootstrapVue from 'bootstrap-vue';
import validationMessagesES from './data/validationMessagesES';
import router from './router';
import store from './store';
import Axios from 'axios';

// Configuramos Axios
// Axios.defaults.baseURL = 'http://localhost:3000/';
// API_URL viene de la confguracion de entorno en /config
Axios.defaults.baseURL = process.env.API_URL;
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//Componentes globales
import TopBar from './components/TopBar.vue';

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
	fieldsBagName: 'fieldsValidation',
	dictionary: {
		es: {
			messages: validationMessagesES
		}
	},
	locale: 'es',
	delay: 1000
});

Vue.use(BootstrapVue);

Vue.component('top-bar', TopBar);

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {App},
	template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js